import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseCreateDto } from '../../base/baseCreate.dto'

@ArgsType()
export class CreateMessagePostDto extends BaseCreateDto<CreateMessagePostDto> {
  @Field(t => Int)
  threadId!: number

  @Field()
  message!: string

  // Really we NEED one or the other of these but its hard to represent that in the graph
  @Field(t => Int, { nullable: true })
  penNameId?: number

  @Field(t => Int, { nullable: true })
  arcTeamId?: number
}
